import React from 'react';

const VARIANT_STYLES = {
  neutral: 'bg-axial-500',
  success: 'bg-emerald-500',
  warning: 'bg-amber-500',
  risk: 'bg-red-500',
};

function ProgressBar({ value = 0, variant = 'neutral', count = null }) {
  const bounded = Math.max(0, Math.min(100, Number(value) || 0));

  return (
    <div className="w-full">
      <div className="h-2 w-full overflow-hidden rounded-full bg-gray-700">
        <div
          className={`h-full rounded-full ${VARIANT_STYLES[variant] || VARIANT_STYLES.neutral}`}
          style={{ width: `${bounded}%` }}
        />
      </div>
      <p className="mt-1 text-[11px] text-gray-400">
        {bounded}%{count && <span className="ml-1">({count})</span>}
      </p>
    </div>
  );
}

export default ProgressBar;
